import { GetListRes } from './GetListRes';

export enum TableColumnKey {
  ID = 'id',
  MERCHANT_NAME = 'merchantName',
  BATCH_ID = 'batchId',
  OPERATION_TYPE = 'operationType',
  CHAIN_NAME = 'chain',
  ASSET_NAME = 'assetName',
  SIGNER_ADDRESS = 'signerAddress',
  // APPROVAL_PROGRESS = 'approvalProgress',
  TOTAL_OPERATION = 'totalOperation',
  // REQUEST_TIME = 'requestTime',
  STATUS = 'status',
  RESULT = 'result',
  // CREATED_BY = 'createdBy',
  // CREATED_DATE = 'createdDate',
  LAST_MODIFIED_BY = 'lastModifiedBy',
  LAST_MODIFIED_DATE = 'lastModifiedDate',
}

export interface TableRow {
  [TableColumnKey.ID]: number;
  [TableColumnKey.MERCHANT_NAME]: string;
  [TableColumnKey.BATCH_ID]: number;
  [TableColumnKey.OPERATION_TYPE]: string;
  [TableColumnKey.CHAIN_NAME]: string;
  [TableColumnKey.ASSET_NAME]: string;
  [TableColumnKey.SIGNER_ADDRESS]: string;
  // [TableColumnKey.APPROVAL_PROGRESS]: string;
  [TableColumnKey.TOTAL_OPERATION]: number;
  // [TableColumnKey.REQUEST_TIME]: string;
  [TableColumnKey.STATUS]: string;
  [TableColumnKey.RESULT]: string;
  // [TableColumnKey.CREATED_BY]: string;
  // [TableColumnKey.CREATED_DATE]: string;
  [TableColumnKey.LAST_MODIFIED_BY]: string;
  [TableColumnKey.LAST_MODIFIED_DATE]: string;
  rawData: GetListRes;
}
